let vrpConfig = {
	style: "plain",
	locale: "de",
	maskCvv: true,
	iframeStyles: {
		'card-number-placeholder': {
			'color': '#777575',
			'font-weight': 'italic',
			'opacity': '1'
		},
		'cvv-placeholder': {
			'color': '#777575',
			'font-weight': 'italic',
			'opacity': '1'
		},
	},
	showCVVHint: true,
	displayBic: true,
}

export default vrpConfig



